import { normalizeFitMetricName, type FitRecordedMetric } from './fitRecordedMetrics';
import { isRunningWorkout, type RunningWorkout } from './runningWorkoutMetrics';

/** Interpret native FIT cycle counts using the activity sport, never CIQ names. */
export function fitMovementCount(metric: FitRecordedMetric, workout?: RunningWorkout) {
  if (/^ciq_/i.test(metric.name)) return null;
  const name = normalizeFitMetricName(metric.name);
  if (!['total_cycles', 'total_strides', 'total_steps'].includes(name)) return null;
  const unit = metric.unit.trim().toLowerCase();
  if (!['cycles', 'strides', 'steps'].includes(unit)) return null;

  // FIT maps total_cycles to total_strides for running (1) and walking (11).
  // https://github.com/garmin/fit-java-sdk/blob/main/src/main/java/com/garmin/fit/SessionMesg.java
  const running = workout != null && (isRunningWorkout(workout) || workout.fit_sport === 11);
  if (unit === 'steps' || ((running || name === 'total_strides') && ['cycles', 'strides'].includes(unit))) {
    const fromStrides = unit !== 'steps';
    const steps = (value: number | null) => value == null ? null : value * (fromStrides ? 2 : 1);
    return {
      kind: 'steps' as const, group: 'running', fromStrides,
      // Keep the server snapshot untouched; only the display copy uses steps.
      metric: { ...metric, unit: 'steps', min: steps(metric.min), avg: steps(metric.avg), max: steps(metric.max) },
    };
  }
  const cycling = workout?.fit_sport === 2 || (workout?.fit_sport == null && [2, 8].includes(workout?.workout_type?.id ?? 0));
  return { kind: cycling ? 'pedalRevolutions' as const : 'cycles' as const, group: cycling ? 'cycling' : 'technical', fromStrides: false, metric };
}
